interface IAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface IPlaceUtil {
  streetNumber: string;
  route: string;
  city: string;
  county: string;
  state: string;
  country: string;
  postalCode: string;
  postalCodeSuffix: string;
}

export default class PlaceUtil implements IPlaceUtil {
  public streetNumber;
  public route;
  public city;
  public county;
  public state;
  public country;
  public postalCode;
  public postalCodeSuffix;

  private addressComponents;

  constructor(addressComponents) {
    this.addressComponents = addressComponents;

    const streetNumber = this.getByTypes(['street_number']);
    this.streetNumber = streetNumber ? streetNumber.short_name : '';

    const route = this.getByTypes(['route']);
    this.route = route ? route.short_name : '';

    const city = this.getByTypes(['locality', 'political']);
    this.city = city ? city.short_name : '';

    const county = this.getByTypes([
      'administrative_area_level_2',
      'political',
    ]);
    this.county = county ? county.short_name : '';

    const state = this.getByTypes(['administrative_area_level_1', 'political']);
    this.state = state ? state.short_name : '';

    const country = this.getByTypes(['country', 'political']);
    this.country = country ? country.short_name : '';

    const postalCode = this.getByTypes(['postal_code']);
    this.postalCode = postalCode ? postalCode.short_name : '';

    const postalCodeSuffix = this.getByTypes(['postal_code_suffix']);
    this.postalCodeSuffix = postalCodeSuffix ? postalCodeSuffix.short_name : '';
  }

  public getStreetNumber(): string {
    return this.streetNumber;
  }

  public getRoute(): string {
    return this.route;
  }

  public getAddress(): string {
    return `${this.streetNumber} ${this.route}`;
  }

  public getCity(): string {
    return this.city;
  }

  public getCounty(): string {
    return this.county;
  }

  public getState(): string {
    return this.state;
  }

  public getCountry(): string {
    return this.country;
  }

  public getPostalCode(): string {
    return this.postalCode;
  }

  public getPostalCodeSuffix(): string {
    return this.postalCodeSuffix;
  }

  private getByTypes(types): IAddressComponent {
    const component =
      this.addressComponents &&
      this.addressComponents.find(comp => {
        let passes = true;
        types.forEach(type => {
          if (!comp.types.includes(type)) {
            passes = false;
          }
        });
        return passes;
      });
    return component;
  }
}
